(function($){
    $(document).ready(function() {

        var CustomHover = function(elem,style) {
            var self = this;
            this.element = elem;

            this._addHover = function(value) {
                var color = $(value).attr('data-hover-cl');
                var initColor = $(value).css(style);
                $(value).on('mouseenter',function() {
                    $(value).css(style,color);
                });
                $(value).on('mouseleave',function() {
                    $(value).css(style,initColor);
                });
            };

            this.init = function() {
                self.element.each(function(key,value) {
                    self._addHover(value);
                });
            };

            this.init();
        };

        var BreadCrumbsHover = function(elem,style) {
            var self = this;
            this.element = elem;
            this.items = self.element.find('span[property="name"]');
            this.itemsLength = this.items.length;
            this.color = elem.attr('data-hover-cl');
            this._addHover = function(value) {
                var initColor = $(value).css(style);
                $(value).on('mouseenter',function() {
                    $(value).css(style,self.color);
                    $(value).find('span').css(style,self.color);
                });
                $(value).on('mouseleave',function() {
                    $(value).css(style,initColor);
                    $(value).find('span').css(style,initColor);
                });
            };

            this._setColor = function(value) {
                value.css(style,self.color);
            };

            this.init = function() {
                this.items.each(function(key,value) {
                    if(key < self.itemsLength-1) {
                        self._addHover($(value).closest('a'));
                    } else {
                        self._setColor($(value));
                    }
                });
            };

            this.init();
        };

        var hoverOnCategories = new CustomHover($('.js-hover'),'background-color');
        var hoverOnBreadCrumbs = new BreadCrumbsHover($('.js-breadcrumbs-hover'),'color');
    });
})(jQuery);